import React, { useContext } from "react";
import { AudioInfo, Icon, OverlayMask } from "./styles";
import { AuthContext } from "../../../context/AuthProvider";

export const DragDropAudioOverlay = ({ show }) => {
  const user = useContext(AuthContext);
  const supportedAudioFormats = user.user.variationEditor
    ? ".wav"
    : ".mp3, .wav";

  return (
    <OverlayMask show={show}>
      <div id="overlay-message-box">
        <div id="overlay-message">
          <h4>Drop audio files to add reference tracks to your mix</h4>
          <p>Supported formats: {supportedAudioFormats}</p>
          {user.user.variationEditor && (
            <AudioInfo>
              <Icon src={require("../../../assets/info.svg")} />
              <div>
                Only uncompressed .wav audio files are supported for content
                creators.
              </div>
            </AudioInfo>
          )}
          <img
            src={require("../../../assets/sound-waves.svg")}
            alt="upload-waveform"
          />
        </div>
      </div>
    </OverlayMask>
  );
};
